export default __webpack_public_path__ + "static/img2-587c6825dc7f8a79f5ad65d52dff6f51.jpg";